import useRequest, { IDataRequest, IEnumRecord, IJustificativaRequest } from '@hooks/useRequest';
import { EnumExcedenteStatus, IExcedente } from '@model/Excedente';
import { IExcedenteItem } from '@model/ExcedenteItem';
import React from 'react';

export interface IExcedenteFilter {
    numero: string
    competencia: string
    excedenteStatus: EnumExcedenteStatus

}

export interface IImportarRequest {
    competencia: string
    inicio: Date
    termino: Date
}


const controller = "/Excedente";

export function useExcedenteService () {
    const _request = useRequest();

    const listar = React.useCallback((request: IDataRequest<IExcedenteFilter>) => {
        return _request.getData<IExcedente[]>(`${controller}/Listar`, request);
    }, [_request]);

    const importar = React.useCallback((arquivo: File, request: IImportarRequest) => {
        const formData = new FormData();
        formData.append('arquivo', arquivo);
        formData.append('competencia', request.competencia.toString());
        formData.append('inicio', request.inicio?.toDateString());
        formData.append('termino', request.termino?.toDateString());

        return _request.upload<IExcedente>(`${controller}/Importar`, formData);
    }, [_request]);

    const listarStatusAtivos = React.useCallback(() => {
        return _request.get<IEnumRecord<EnumExcedenteStatus>[]>(`${controller}/ListarStatusAtivos`);
    }, [_request]);

    const cancelar = React.useCallback((excedenteId: number, request: IJustificativaRequest) => {
        return _request.post<IExcedente>(`${controller}/Cancelar/${excedenteId}`, request);
    }, [_request]);

    const listarItens = React.useCallback((excedenteId: number) => {
        return _request.get<IExcedenteItem[]>(`${controller}/ListarItens/${excedenteId}`);
    }, [_request]);

    return React.useMemo(() => ({
        listar, importar, listarStatusAtivos, cancelar, listarItens
    }), [listar, importar, listarStatusAtivos, cancelar, listarItens]);
}